/* Position paths expressed as harmonics of one base frequency — the same table
   the extension's position oscillators play. Shared by the audio loop (which
   sets the real PannerNode) and the three.js scene (which draws the orb), so
   the sound you hear and the source you see can never drift apart. */
export type Harmonics = { real?: Record<number, number>; imag?: Record<number, number> };
export type Path = { base: number; x: Harmonics; z: Harmonics };

export const PATHS: Record<string, Path> = {
  orbit:    { base: 1,   x: { imag: { 1: 1 } },             z: { real: { 1: -1 } } },
  figure8:  { base: 1,   x: { imag: { 1: 1 } },             z: { imag: { 2: 0.6 } } },
  drift:    { base: 0.1, x: { imag: { 7: 0.7, 19: 0.28 } }, z: { real: { 5: 0.7 }, imag: { 13: 0.28 } } },
  sine:     { base: 1,   x: { imag: { 1: 1 } },             z: { real: { 1: -0.15 } } },
  triangle: { base: 1,   x: { imag: { 1: 1, 3: -0.16 } },   z: { imag: { 2: 0.5 } } },
  none:     { base: 1,   x: {},                             z: {} },
};

export function pathValue(spec: Harmonics | undefined, base: number, a: number): number {
  if (!spec) return 0;
  let v = 0;
  for (const [k, c] of Object.entries(spec.real ?? {})) v += c * Math.cos(Number(k) * base * a);
  for (const [k, c] of Object.entries(spec.imag ?? {})) v += c * Math.sin(Number(k) * base * a);
  return v;
}

/* Bass energy of the low ~8 FFT bins, 0..1. Pure so the beat-reactive scaling
   has one runnable check. */
export function bassLevel(freq: Uint8Array, bins = 8): number {
  const n = Math.min(bins, freq.length);
  if (n === 0) return 0;
  let sum = 0;
  for (let i = 0; i < n; i++) sum += freq[i];
  return sum / (n * 255);
}
